import { extractImageFrames, clampTo } from '../tools';
import type { youchuanModelConfig } from './types';

export const youchuanModelConfigs: Record<string, youchuanModelConfig> = {
    'youchuan-video': {
        // https://tob.youchuan.cn/docs/apis/%E8%A7%86%E9%A2%91%E7%94%9F%E6%88%90/api_videodiffusion
        apiPath: '/v1/tob/video-diffusion',
        pollApiPath: '/v1/tob/job/{id}',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            videoUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, quality, modelUi } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    prompt: `${firstImage} ` + prompt.slice(0, 8000) + ' --bs 1',
                    videoType: clampTo(quality || '480p', ['480p', '720p'] as const, '720p') === '480p' ? 0 : 1,
                    // system
                    jobId: undefined,
                    imageNo: undefined,
                    callback: undefined,
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    prompt: `${firstImage} ` + prompt.slice(0, 8000) + ' --bs 1' + ' --end ' + lastImage,
                    videoType: clampTo(quality || '480p', ['480p', '720p'] as const, '720p') === '480p' ? 0 : 1,
                    // system
                    jobId: undefined,
                    imageNo: undefined,
                    callback: undefined,
                };
            } else {
                throw new Error('Invalid frame mode');
            }
        },
    },
};